import { env } from "../env";
import { IDocumentStatusInfoProps } from "./DocumentStatusInfo";
/*import "@pnp/sp/webs";
import "@pnp/sp/lists";
import "@pnp/sp/items";
import "@pnp/sp/folders";
import "@pnp/sp/content-types";
*/

type DocumentStatusInfoData = {
    requestedDocVersion?: number;
    publishedDocVersion?: number;
    publishedDocEmbedUrl?: string;
    publishedDocFileUrl?: string;
    publishedDocFolderUrl?: string;
    requestedDocVersionUrl?: string;
    publishedDocTitle?: string;
    error?: string;
}
export const fetchDocumentStatusInformation = async (props: IDocumentStatusInfoProps): Promise<DocumentStatusInfoData> => {
    var result: DocumentStatusInfoData = {};

    var url = "/api/v1/GetDocumentStatusInfo?" + new URLSearchParams(window.location.search);
    console.log("url", url);
    const response = await fetch(url, {
        headers: {
            'Content-Type': 'application/json', // Set content type as JSON
        },
    })

    result = await response.json();
    return result;
}